import { LinearProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import SearchBar from "./search-bar.component";
import { Status } from "./search-bar.slice";
import SearchResults from "./search-results.component";
import "./search.css";
import { useEffect } from "react";
import { loadRecentShows } from "./search.slice";
import RecentShows from "./recent-shows.component";

const Search = () => {
    const dispatch: any = useDispatch();
    const {results: searchResults, status: searchResultsStatus} = useSelector((state: RootState) => state.searchBar);
    const {details: recentShows, status: recentShowsStatus} = useSelector((state: RootState) => state.recentShows);

    useEffect(() => {
        dispatch(loadRecentShows());
    }, [dispatch]);

    return (
        <>
            <div className="searchWrapper">
                <SearchBar />
                <div className="loadingBar">
                    {searchResultsStatus === Status.LOADING && <LinearProgress  />}
                </div>
                <SearchResults searchResults={searchResults}/>
            </div>
            {searchResultsStatus === Status.INACTIVE && recentShowsStatus === Status.SUCCESSFUL && recentShows?.data?.length > 0 &&
                <RecentShows shows={recentShows.data}/>
            }
        </>
    );
}

export default Search;